var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:#463C2F;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.7691 0 0 2.7691 -442.3 -441.91)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m228.24 172.45 9.69-1.35v-2.48h-33.46v2.48l10.36 1.58 8.45 23.66-16.45 43.03-24.23-66.7 10.25-1.58v-2.48h-31.32v2.48l7.55 1.58 31.77 88.34h0.9l22.99-60.73 15.71 43.43 7.09-18.49z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "276.91 176.16 264.18 171.1 264.18 168.61 288.41 168.61 288.41 171.1 279.85 176.05 254.59 242.63 247.2 261.01 223.08 323.84 235.81 328.91 235.81 331.39 211.59 331.39 211.59 328.91 220.15 323.95 245.4 257.37 252.79 239"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m330.91 327.33-31.78-88.33h-0.9l-22.98 60.72-15.58-43.07-7.09 18.48 19.18 52.42-9.69 1.36v2.48h33.47v-2.48l-10.36-1.58-8.45-23.66 16.45-43.04 24.22 66.7-10.25 1.58v2.48h31.33v-2.48z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m284.13 233.08 3.15-22.46c1.09-6.51 5.61-13.04 13.23-13.04 7.31 0 13.25 5.94 13.25 13.25 0 5.47-3.44 10.28-8.97 12.54l-0.21 0.09zm16.38-32.5c-5.88 0-9.39 5.27-10.27 10.5l-2.37 16.92 15.78-7.41c4.39-1.79 7.11-5.54 7.11-9.76 0-5.65-4.6-10.25-10.25-10.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m200.38 303.01c-7.31 0-13.25-5.94-13.25-13.25 0-5.47 3.44-10.28 8.97-12.54l0.21-0.09 20.46-9.63-3.15 22.46c-1.1 6.52-5.61 13.05-13.24 13.05zm12.65-30.43-15.77 7.41c-4.4 1.8-7.12 5.54-7.12 9.77 0 5.65 4.6 10.25 10.25 10.25 5.88 0 9.39-5.27 10.27-10.5z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.d88c0fa42bb7b4936e27a5b4f6b70e65.svg";